export class Registry {
  private readonly dependencies = new Map<string, unknown>();
  private static instance: Registry | undefined;

  private constructor() {}

  provide<T>(name: string, dependency: T): void {
    this.dependencies.set(name, dependency);
  }

  inject<T>(name: string): T {
    const dep = this.dependencies.get(name);
    if (!dep) throw new Error(`[Registry] Dependency "${name}" not found`);
    return dep as T;
  }

  has(name: string): boolean {
    return this.dependencies.has(name);
  }

  static getInstance(): Registry {
    if (!Registry.instance) {
      Registry.instance = new Registry();
    }
    return Registry.instance;
  }

  /** Limpa todas as dependências — útil para testes */
  static reset(): void {
    Registry.instance = undefined;
  }
}
